import { Pipe, PipeTransform } from "@angular/core";
import { CustomerOnssSize } from "src/app/customers/shared/model/customer.model";

interface CustomerOnssSizeOptions {
  value: string; 
  label: string; 
}

export const ONSS_SIZE_OPTIONS: CustomerOnssSizeOptions[] = [
  { value: CustomerOnssSize.ONSS_SIZE_1, label: '1 (1-4 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_2, label: '2 (5-9 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_3, label: '3 (10-19 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_4, label: '4 (20-49 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_5, label: '5 (50-99 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_6, label: '6 (100-199 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_7, label: '7 (200-499 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_8, label: '8 (500-999 workers)' },
  { value: CustomerOnssSize.ONSS_SIZE_9, label: '9 (1000+ workers)' },
];

@Pipe({
  name: 'onssSizeLabel',
})

export class OnssSizeLabelPipe implements PipeTransform {

  transform(selectedValue: string | null | undefined): string {
    if (!selectedValue) {
      return '';
    }

    const sizeOption = ONSS_SIZE_OPTIONS.find(option => option.value === selectedValue);
    
    return sizeOption ? sizeOption.label : selectedValue;
  }
}